var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreIllustration = function SvgStoreIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#store_illustration_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6F2F0",
    d: "M45.27 12.844H8.25A2.25 2.25 0 0 0 6 15.094V51.61a2.25 2.25 0 0 0 2.25 2.25h37.02a2.25 2.25 0 0 0 2.25-2.25V15.094a2.25 2.25 0 0 0-2.25-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M13.553 23.063c.465 0 .843.377.843.843V45.42h35.235V23.906a.844.844 0 0 1 1.688 0v22.358a.844.844 0 0 1-.844.844H13.553a.844.844 0 0 1-.844-.844V23.906c0-.466.377-.843.844-.843M14.783 6.08a.84.84 0 0 1 .75-.455h32.962c.315 0 .604.176.75.456l4.9 9.465a.844.844 0 1 1-1.498.776l-4.665-9.01H16.046l-4.665 9.01a.844.844 0 1 1-1.499-.776z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M42.705 15.09c.466 0 .844.378.844.844v3.1199999999999997a4.502 4.502 0 0 0 7.728 3.261 4.5 4.5 0 0 0 1.276-3.283v-3.098a.844.844 0 0 1 1.687 0v3.087a6.192 6.192 0 1 1-12.379 0v-3.087c0-.466.378-.844.844-.844M10.631 15.09c.466 0 .844.378.844.844v3.1199999999999997a4.504 4.504 0 1 0 9.004-.022v-3.098a.844.844 0 1 1 1.687 0v3.087a6.192 6.192 0 1 1-12.378 0v-3.087c0-.466.377-.844.843-.844",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M21.322 15.09c.466 0 .844.378.844.844v3.12a4.504 4.504 0 1 0 9.004-.022v-3.098a.844.844 0 0 1 1.687 0v3.087a6.192 6.192 0 1 1-12.378 0v-3.087c0-.466.377-.844.843-.844",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M32.014 15.09c.466 0 .844.378.844.844v3.12a4.504 4.504 0 1 0 9.003-.022v-3.098a.844.844 0 0 1 1.688 0v3.087a6.192 6.192 0 1 1-12.379 0v-3.087c0-.466.378-.844.844-.844",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M32.014 5.625c.466 0 .843.378.843.844v9.465a.844.844 0 1 1-1.687 0V6.469c0-.466.378-.844.844-.844M40.41 5.645a.844.844 0 0 1 1.007.64l2.111 9.465a.844.844 0 1 1-1.647.368l-2.11-9.465a.844.844 0 0 1 .639-1.008M23.617 5.645a.844.844 0 0 1 .64 1.008l-2.111 9.465a.844.844 0 0 1-1.647-.368l2.111-9.465a.844.844 0 0 1 1.007-.64M18.259 29.745c0-.466.378-.844.843-.844h9.484c.466 0 .844.378.844.844V46.26a.844.844 0 0 1-.844.844h-9.483a.844.844 0 0 1-.844-.844zm1.687.844v14.828h7.796V30.589zM32.591 29.745c0-.466.378-.844.844-.844h11.576c.466 0 .844.378.844.844v8.839a.844.844 0 0 1-.844.844H33.435a.844.844 0 0 1-.844-.844zm1.688.844v7.151h9.889V30.59z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M9.788 15.934c0-.466.377-.844.843-.844h42.765a.844.844 0 0 1 0 1.688H10.631a.844.844 0 0 1-.843-.844",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "store_illustration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export default SvgStoreIllustration;